<div><label>URL:</label> <span class="value" data-testid="url">{{ configuration.url }}</span></div>
<div><label>Client:</label> <span class="value" data-testid="client">{{ configuration.client }}</span></div>
<div><label>Username:</label> <span class="value" data-testid="user">{{ configuration.userName }}</span></div>
@if (editable) {
  <div class="button-container">
    <button mat-raised-button color="primary" data-testid="edit" (click)="edit()">Edit</button>
  </div>
}
